module.exports = __webpack_public_path__ + "img/violet_118.e0885219.png";